<template>
  <b-field>
    <b-input v-model="val" />
  </b-field>
</template>

<script>
import SchemaFormElementMixin from '@/mixins/SchemaFormElementMixin'

export default {
  name: 'SchemaFormElementText',
  mixins: [SchemaFormElementMixin]
}
</script>
